// extracted by mini-css-extract-plugin
export var menuItem = "B_tz d_fW d_bw d_bz d_bL d_bb";
export var menuItemSub = "B_tB d_W d_bw d_bL";
export var menuMainLink = "B_tC d_fX d_dx";
export var menuLink = "B_tD d_fX d_dx";
export var Link = "B_rP t_rP t_q1 t_rl";